import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=5e7eeae1&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7eeae1')) {
      api.createRecord('5e7eeae1', component.options)
    } else {
      api.reload('5e7eeae1', component.options)
    }
    module.hot.accept("./logout.vue?vue&type=template&id=5e7eeae1&", function () {
      api.rerender('5e7eeae1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/account/logout.vue"
export default component.exports